import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore, AngularFirestoreDocument } from "@angular/fire/firestore";
import firebase from "firebase/app";
import { Observable, of } from "rxjs";
import { switchMap, first } from "rxjs/operators";

@Injectable()
export class AuthProvider {
  user: Observable<any>;

  constructor(
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore
  ) {
    this.user = this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          return this.afs.doc<any>(`users/${user.uid}`).valueChanges();
        } else {
          return of(null);
        }
      })
    );
  }

  async emailLogin(email: string, password: string) {
    try {
      await this.afAuth.auth.setPersistence(firebase.auth.Auth.Persistence.SESSION).then(async () => {
        await this.afAuth.auth.signInWithEmailAndPassword(email, password);
      });
    } catch (err) {
      throw new Error(err);
    }
  }

  async sendPasswordResetEmail(email: string) {
    try {
      return await this.afAuth.auth.sendPasswordResetEmail(email)
    } catch (err) {
      throw new Error(err);
    }
  }

  getUserToken()  {
    return new Promise((resolve, reject) => {
      this.afAuth.auth.currentUser.getIdToken().then((token) => { 
        resolve(token);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  async updateCustomUserData(data) {
    this.user = this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          const userRef: AngularFirestoreDocument<any> = this.afs.doc(
            `users/${user.uid}`
          );
          return userRef.set(data, { merge: true });
        }
      })
    );
  }

  private updateUserData(user: any, data: any) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(
      `users/${user.uid}`
    );
    return userRef.set(data, { merge: true });
  }

  async logout(): Promise<any> {
    return this.afAuth.auth.signOut();
  }

  async getCurrentUser(): Promise<any> {
    return this.user.pipe(first()).toPromise();
  }

  async isLoggedIn(): Promise<boolean> {
    const user = await this.getCurrentUser();
    return !!user;
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts